export const HEADERS = [
	'No.',
	'Name',
	'Buyer note',
	'Correction Reasons',
	'Description',
	'Actions',
];
